import { memo, useMemo } from 'react';
import { Checkbox, Tooltip } from '@ds';
import { AdminFormRow, ConditionalRender } from '@ui';
import { CUSTOMER_PERMISSION_DESCRIPTIONS, CUSTOMER_PERMISSION_NAMES } from '@/constants/customer.constants';
import { CustomerPermissionOnly, CustomerRoleEnum } from '@/api/apis/customer';
import { getCustomerPermissionNames } from '@/utils/helpers';
import { ControlledCheckboxGroup } from '../components/inputs/ControlledCheckboxGroup';

export type PermissionSelectorProps = {
  name: string;
  roleValues: CustomerRoleEnum[];
  permissionValues: CustomerPermissionOnly[];
  handlePermissionChange: (newPermissions: string[]) => void;
  isReadOnly?: boolean;
};

export const PermissionSelector = memo(
  ({ name, roleValues, permissionValues, handlePermissionChange, isReadOnly = false }: PermissionSelectorProps) => {
    const displayedPermissions = useMemo(
      () => getCustomerPermissionNames(Object.keys(CUSTOMER_PERMISSION_NAMES) as CustomerPermissionOnly[]),
      [],
    );

    return (
      <AdminFormRow title="Permission">
        <ControlledCheckboxGroup
          name={name}
          orientation="horizontal"
          value={permissionValues}
          onChange={handlePermissionChange}
          isDisabled={isReadOnly || !roleValues.length}
        >
          {displayedPermissions.map((item) => (
            <Tooltip
              className="text-m-r!"
              content={<div className="max-w-[320px]">{CUSTOMER_PERMISSION_DESCRIPTIONS[item.value]}</div>}
              showArrow
              key={item.value}
            >
              <Checkbox size="md" value={item.value} className="p-0 m-2" isDisabled={isReadOnly || !roleValues.length}>
                {item.name}
              </Checkbox>
            </Tooltip>
          ))}
        </ControlledCheckboxGroup>
        <ConditionalRender show={!roleValues.length}>
          <p className="text-base-20 text-xs">At least one role must be selected to add permissions.</p>
        </ConditionalRender>
      </AdminFormRow>
    );
  },
);
